import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createPortal } from 'react-dom';

import isServer from 'commons/isServer';
import IconClose from 'components/icons/iconClose';
import { colorWhite } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';

const SnackbarRootElement = !isServer()
  ? document.getElementById('Snackbar-root')
  : null;

const Snackbar = ({ children, isOpen, onClose }) =>
  createPortal(
    <div
      className={classNames(
        'bottom-0 justify-center left-0 pt-0 px-4 pb-4 right-0 fixed transition-[opacity_.2s_ease-in-out]',
        {
          'hidden opacity-0': !isOpen,
          'flex opacity-100': isOpen,
        }
      )}
    >
      <div
        className={classNames(
          'text-xs bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover font-bold items-center rounded text-white flex',
          {
            'Snackbar--isOpen': isOpen,
          }
        )}
      >
        <div className="pt-3 pr-0 pb-3 pl-5">{children}</div>

        <button
          className="[background:none] border-0 pt-3 pr-5 pb-3 pl-4 hover:cursor-pointer"
          onClick={onClose}
          type="button"
        >
          <IconClose color={colorWhite} height={10} width={10} />
        </button>
      </div>
    </div>,
    SnackbarRootElement
  );

Snackbar.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withBrowserOnly(Snackbar);
